import { useFormContext } from 'react-hook-form';

import { Fields } from '../constants';
import type { SecretFormValues } from '../schemas';

export const useUpdateSecretForm = () => {
    const {
        formState: { isDirty, isSubmitting, errors },
        getValues,
    } = useFormContext<SecretFormValues>();

    const submitError = errors?.root;

    const secretType = getValues(Fields.TYPE);

    return {
        isDirty,
        isSubmitting,
        submitError,
        secretType,
    };
};
